import React from "react";
import classes from "../memory.module.css";
import TypographyInline from "../../../components/Typography/TypographyInline";
import { GREY, BASE } from "../../../utils/constants/colors";
import { fontWeight } from "../../../utils/constants/UI";

const MemoryOption = ({ title, description, asset, onClick, disabled }) => {
  return (
    <div className={`${classes.optionCard} ${disabled ? classes.disabledCard : ""}`} onClick={onClick}>
      <div className={classes.assetContainer}>
        <img src={asset} alt={title} className={classes.assetIcon} />
      </div>
      <div className={classes.textContainer}>
        <TypographyInline
          label={title}
          size="lg"
          fontWeight={fontWeight.BOLD}
          color={BASE.BLACK}
        />
        <TypographyInline
          label={description}
          size="sm"
          fontWeight={fontWeight.REGULAR}
          color={GREY.SECONDARY}
        />
      </div>
    </div>
  );
};

export default MemoryOption;
